<template>
	<div class="chairman">
		<Title :zhTitle="pageData.name" :enTitle="pageData.name"></Title>

		<div class="content">
			<div v-if="language === 'zh'">
        <div class="describe">
          <div class="discribe1" v-text="jsonData.wishes"></div>
          <div class="bottom">
            {{ jsonData.inscribe }}
            <img v-if="jsonData.likeness" :src="jsonData.likeness" />
          </div>
        </div>
			</div>

      <div v-else-if="language === 'en'">
        <div class="describe">
          <div class="discribe1" v-text="jsonData.wishesEng"></div>
          <div class="bottom">
            {{ jsonData.inscribeEng }}
            <img v-if="jsonData.likeness" :src="jsonData.likeness" />
          </div>
        </div>
			</div>

		</div>
	</div>
</template>

<script>
import Title from '@/components/title.vue'
import { mapState } from 'vuex'

export default {
	name: 'chairman',
	components: {
		Title,
	},
	props: {
		index: {
			type: Number,
		},
	},
	data() {
		return {
			pageData: {},
			customData: [],
		}
	},
	computed: {
		...mapState(['theme', 'language', 'jsonData']),
	},
  watch:{
    language(newVal, oldVal) {
      let data = JSON.parse(this.jsonData.moduleData)
      if (newVal == 'zh') {
        data = JSON.parse(this.jsonData.moduleData)
      } else {
        data = JSON.parse(this.jsonData.moduleDataEng)
      }
      this.pageData = data[this.index]
    }
  },
	mounted() {
		let data = JSON.parse(this.jsonData.moduleData)
		if (this.language == 'zh') { // 根据语言获取相应数据
			data = JSON.parse(this.jsonData.moduleData)
		} else {
			data = JSON.parse(this.jsonData.moduleDataEng)
		}
		this.pageData = data[this.index]
	},
	methods: {},
}
</script>

<style lang="scss" scoped>
.red {
	.chairman {
		margin-top: 14px;
		width: 1040px;
		height: 503px;
		position: relative;
		background: #ffffff;
		box-shadow: 2px 2px 10px 6px rgba(211, 47, 46, 0.07);
    border: 1px solid rgba(211, 47, 46, 0.07);
	}
  .bottom {
    bottom: -80px;
  }
}

.purple {
	.chairman {
		margin-top: 14px;
		width: 1040px;
		height: 503px;
		position: relative;
		background: #ffffff;
		box-shadow: 2px 2px 10px 6px rgba(211, 47, 46, 0.07);
    border: 1px solid rgba(211, 47, 46, 0.07);
	}
}

.content {
	margin-top: 48px;
	margin-left: 57px;
	position: relative;
}

.describe {
	width: 870px;
  height: 300px;
	overflow-y: auto;
	border-radius: 8px;
  border: 1px solid var(--borderColor);
	padding-top: 28px;
	padding-left: 23px;
	padding-right: 33px;
	font-size: 16px;
	font-weight: 400;
	color: var(--timeTitleColor);
	line-height: 28px;
}
.discribe1 {
  min-height: 150px;
  max-height: 192px;
  overflow-y: auto;
  margin-bottom: 20px;
  white-space: pre-wrap;
}
.purple {
	.describe {
		border: none;
	}
}
.describe p {
	margin: 0;
	text-indent: 2em;
}
.bottom {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	font-size: 14px;
	font-weight: 400;
	color: var(--timeTitleColor);
}
.bottom img {
	width: 73px;
	height: 73px;
	margin-left: 11px;
	border-radius: 100%;
}
.blue {
	.chairman {
		padding: 0 80px;
		padding-top: 27px;
		width: 980px;
		height: 489px;
		position: relative;
	}
	.content {
		margin: 0;
		margin-top: 34px;
		width: 836px;
		height: 297px;
		background: #ecf2fd;
		border-radius: 8px;
		padding: 39px 72px;
	}

	.describe {
		padding: 0;
		width: 836px;
		border-radius: 8px;
		border: none;
		font-size: 17px;
		font-weight: 400;
		color: var(--timeTitleColor);
		line-height: 32px;
	}
  .bottom {
    bottom: 20px;
    right: 80px;
  }
}
.yellow {
	.chairman {
		width: 980px;
		height: 510px;
		padding: 0 80px;
		background: #f5f6f8;
		border-radius: 28px;
		position: relative;
	}
	.content {
		margin: 0;
		margin-top: 34px;
		width: 838px;
		height: 297px;
		background: #ffffff;
		box-shadow: 6px 2px 9px 0px rgba(165, 165, 165, 0.2);
		border-radius: 8px;
		padding: 39px 72px;
	}

	.describe {
		padding: 0;
		width: 836px;
		border-radius: 8px;
		border: none;
		font-size: 17px;
		font-weight: 400;
		color: var(--timeTitleColor);
		line-height: 32px;
	}
  .bottom {
    bottom: 20px;
    right: 80px;
  }
}
</style>
